import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LoginService } from '../shared/user-login/login.service';
import { SubscriptionService } from '../shared/customer/subscription/subscription.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-subscription',
    templateUrl: './subscription.component.html',
    styleUrls: ['./subscription.component.css'],
    standalone: false
})
export class SubscriptionComponent implements OnInit {
  userDetails;
  role: string;
  serverErrorMessages: string;
  constructor(private loginService: LoginService, public subscriptionService: SubscriptionService ,private router : Router) { }

  ngOnInit(): void {
    this.loginService.getUserProfile().subscribe(
      res => {
        this.userDetails = res['user'];
        this.role = this.userDetails.ROLE.toUpperCase();
       //console.log('got logged in user', this.userDetails, this.role);
      },
      err => {
       //console.log('Did not get user', err);
      }
    )
  }

  onSubmit(form: NgForm){
   //console.log('Inside subs service', {...form.value, user: this.userDetails})
    this.subscriptionService.subs({...form.value, user: this.userDetails})
    // .subscribe(
    //   res => {
    //    //console.log('Got resp', res)
    //   },
    //   err => {
    //    //console.log('Error subscribing', err);
    //   }
    // )
  }

}
